import React, { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./PMTextEditor.css";
import { useFormikContext } from "formik";
import { TWclassNames } from "./Div";

const PMTextEditor = ({ name, onChange, className }) => {
  const [showToolbar, setShowToolbar] = useState(false);

  // Access Formik context for values and setFieldValue
  const { values, setFieldValue } = useFormikContext();

  // Define a minimal toolbar
  const toolbarOptions = [
    [{ "list": "ordered" }, { "list": "bullet" }],
    ["bold", "italic", "underline"],
  ];

  const handleChange = (content) => {
    setFieldValue(name, content); // Update Formik's field value
    if (onChange) onChange(content); // Call onChange if provided
  };

  return (
    <div
      className={TWclassNames(
        "pm-text-editor relative w-full mx-auto rounded-md",
        className
      )}
      onMouseEnter={() => setShowToolbar(true)}
      onMouseLeave={() => setShowToolbar(false)}
    >
      <ReactQuill
        value={values[name] || ""}
        onChange={handleChange}
        modules={{
          toolbar: toolbarOptions,
        }}
        placeholder="Start typing here..."
        className="border border-gray-300 rounded-md"
        style={{
          minHeight: "120px",
          maxHeight: "200px",
        }}
      />
    </div>
  );
};

export default PMTextEditor;
